(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  function exposeAllMobileLinks() {
    if (!mobile.matches) return;
    document
      .querySelectorAll('#header-component .header__row--bottom overflow-list > .menu-list__list-item')
      .forEach((item) => {
        if (item.getAttribute('slot') === 'more') return;
        if (item.hasAttribute('slot')) item.removeAttribute('slot');
        item.removeAttribute('aria-hidden');
      });
  }

  function init() {
    const list = document.querySelector('#header-component .header__row--bottom overflow-list');
    if (!list) return;
    exposeAllMobileLinks();
    new MutationObserver(exposeAllMobileLinks).observe(list, {
      subtree: false,
      attributes: true,
      attributeFilter: ['slot', 'aria-hidden']
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();
